export default __webpack_public_path__ + "static/media/army_51.c403e16c.jpg";